// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3lGiW","select":"Header_select__2t-Ii","clinic":"Header_clinic__24heh"};